import CryptoJS from "crypto-js";
import { Base64 } from 'js-base64';

import { JSEncrypt } from "jsencrypt";
/* ---------- 签名算法 ---------- */
export const RSSign = (params, key) => {
    const aString = Object.keys(params).filter(key => {
        return (key !== "sign" && key !== "sign_type" && key !== "" && key !== null && params[key] !== "");
    }).sort().reduce((prev, cur) => {
        return prev + `${cur}=${params[cur]}&`;
    }, "");
    return CryptoJS.MD5(`${aString}${key}`).toString();
};

/**
 * AES-256-CBC对称加密
 * @param data {string} 要加密的明文
 * @param key {string} 加密密钥
 * @param iv {string} 初始化向量，通常是随机生成的
 * @returns {string} 加密后的密文，Base64格式
 */
export const Encrypt = (data, key, iv) => {
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    const ivUtf8 = CryptoJS.enc.Utf8.parse(iv);

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), keyUtf8, {
        iv: ivUtf8,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    let encrypt = encrypted.toString();
    const encryptedBase64 = Base64.encode(encrypt);
    return encryptedBase64;
};

/**
 * AES-256-CBC对称解密
 * @param encryptedData {string} 要解密的密文，Base64格式
 * @param key {string} 解密密钥
 * @param iv {string} 初始化向量，同样是加密时所用的初始化向量
 * @returns {string} 解密后的明文
 */
export const Decrypt = (encryptedData, key, iv) => {
    const encryptedBase64 = Base64.decode(encryptedData);
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    const ivUtf8 = CryptoJS.enc.Utf8.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, keyUtf8, {
        iv: ivUtf8,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedText;
};

export const RSA = (data, pKey) => {
    let encryptor = new JSEncrypt()
    encryptor.setPublicKey(pKey)
    return encryptor.encrypt(data)

}
export const RSAdecrypt = (data, pKey) => {
    let encryptor = new JSEncrypt()
    encryptor.setPrivateKey(pKey)
    return encryptor.decrypt(data)
}
